export default __webpack_public_path__ + "static/media/exclamation-triangle.c06f2e24.svg";